export var EthnicityEnum;
(function (EthnicityEnum) {
    EthnicityEnum[EthnicityEnum["None"] = 0] = "None";
    EthnicityEnum[EthnicityEnum["Aboriginal"] = 1] = "Aboriginal";
    EthnicityEnum[EthnicityEnum["TSI"] = 2] = "TSI";
    EthnicityEnum[EthnicityEnum["ATSI"] = 3] = "ATSI";
    EthnicityEnum[EthnicityEnum["NonATSI"] = 999] = "NonATSI";
    EthnicityEnum[EthnicityEnum["NotProvided"] = 9999] = "NotProvided";
})(EthnicityEnum || (EthnicityEnum = {}));
export var PatientUpdateField;
(function (PatientUpdateField) {
    PatientUpdateField[PatientUpdateField["Address"] = 1] = "Address";
    PatientUpdateField[PatientUpdateField["Medicare"] = 2] = "Medicare";
    PatientUpdateField[PatientUpdateField["Phi"] = 3] = "Phi";
    PatientUpdateField[PatientUpdateField["Nok"] = 4] = "Nok";
    PatientUpdateField[PatientUpdateField["Emergency"] = 5] = "Emergency";
    PatientUpdateField[PatientUpdateField["Ethnic"] = 6] = "Ethnic";
})(PatientUpdateField || (PatientUpdateField = {}));
export var PensionCodeEnum;
(function (PensionCodeEnum) {
    PensionCodeEnum[PensionCodeEnum["None"] = 0] = "None";
    PensionCodeEnum[PensionCodeEnum["PensionerConcessionCard"] = 1] = "PensionerConcessionCard";
    PensionCodeEnum[PensionCodeEnum["HealthCareCard"] = 3] = "HealthCareCard";
    PensionCodeEnum[PensionCodeEnum["CommonwealthSeniorsHealthCard"] = 4] = "CommonwealthSeniorsHealthCard";
})(PensionCodeEnum || (PensionCodeEnum = {}));
